import { render, staticRenderFns } from "./AddDiagnosisView.vue?vue&type=template&id=6e79cb72"
import script from "./AddDiagnosisView.vue?vue&type=script&lang=js"
export * from "./AddDiagnosisView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports